<template>
  <el-dialog
      v-if="visible"
      v-dialog-drag
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :visible="visible"
      class="mydialog"
      @close="close">
    <div slot="title" style="display: flex;">
      <div class="mainTitle">异常详情</div>
      <div style="flex:1;"></div>
      <div :class="{maxIcon:!fullscreen, minIcon:fullscreen}" style="width: 20px;cursor: pointer;margin-right:60px;"
           @click="changeScreen">
      </div>
    </div>
    <div style="flex:1;height:1px;display: flex;flex-direction: column;">
      <div
          :style="{
          height:toolHeight+'px'
       }"
          style="background: #fff;box-shadow: 0px 4px 12px rgba(24, 70, 162, 0.06);position: relative;padding:0px 20px;box-sizing: border-box; "
      >
        <div style="height: 100%;width: 100%;overflow: hidden;display: flex;align-items: center">
          <div style="flex:1;text-align: center">
            <div style="text-align: center">基准文件</div>
            <el-cascader
                v-model="baseId"
                :options="base"
                :props="{ emitPath: false }"
                size="mini"
                style="width: 80%;margin: 10px auto"
                @change="baseChange"
            ></el-cascader>
          </div>
          <div style="width: 40px;display: flex;flex-direction:column;justify-content: center;align-items: center;">
            <img alt="" src="@/assets/image/db.png">
            <div>对比</div>
          </div>
          <div style="flex:1;text-align: center">
            <div style="text-align: center">目标文件</div>
            <el-cascader
                v-model="contId"
                :options="cont"
                :props="{ emitPath: false }"
                size="mini"
                style="width: 80%;margin: 10px auto"
                @change="contChange"
            ></el-cascader>
          </div>
          <div class="circle">
            <span style="font-size: 12px;color: #FF7D00;font-weight: bold;">{{ showData.similarity }}</span>
            <div style="font-size: 12px;">相似度</div>
          </div>
          <div class="infoBtn" @click="toggletoolStatus">
             <span v-if="toolStatus">
          收起 <i class="el-icon-arrow-up"></i>
        </span>
            <span v-else>
          展开 <i class="el-icon-arrow-down"></i>
        </span>
          </div>

        </div>
      </div>
      <div v-if="isEmpty"
           style="flex:1;height: 1px;display: flex;flex-direction: column;justify-content: center;align-items: center;">
        <img alt="" src="@/assets/image/empty.png">
        <div style="margin-top: 10px;">没有该文件组合的对比结果，请重新选择</div>
      </div>
      <div v-else style="flex:1;height: 1px;display: flex;flex-direction:column;margin: 30px 0 10px 0;">
        <div style="padding:0px 30px;">
          <el-tabs v-model="activeTag">
            <el-tab-pane v-if="hasPara" label="文本对比结果" name="textSimilar"></el-tab-pane>
            <el-tab-pane v-if="hasImg" label="图片对比结果" name="imageSimilar"></el-tab-pane>
            <el-tab-pane v-if="hasAuthor" label="作者雷同" name="authorSimilar"></el-tab-pane>
            <el-tab-pane v-if="hasPhone" label="电话雷同" name="phoneSimilar"></el-tab-pane>
          </el-tabs>
        </div>
        <div style="flex:1;height: 1px;">
          <text-cmp v-if="activeTag=='textSimilar' && hasPara" :abnormalResult="abnormalResult" :baseId="baseId" :contId="contId"
                    :showData="showData"></text-cmp>
          <img-cmp v-if="activeTag=='imageSimilar' && hasImg" :baseId="baseId" :contId="contId" :imageData="imageData"
                   :showData="showData"></img-cmp>
          <author-cmp v-if="activeTag =='authorSimilar' && hasAuthor" :baseId="baseId" :contId="contId" :showData="showData">
          </author-cmp>
          <phone-cmp v-if="activeTag=='phoneSimilar' && hasPhone" :phoneAbnormalResult="phoneAbnormalResult" :baseId="baseId" :contId="contId"  :showData="showData"></phone-cmp>
        </div>
      </div>
    </div>

  </el-dialog>
</template>
<script>
import {getFileList, getFile} from "@/api/word"
import {mapState} from "vuex";
import imgCmp from "@/views/word/detailCmp/imgCmp";
import textCmp from "@/views/word/detailCmp/textCmp";
import phoneCmp from "@/views/word/detailCmp/phoneCmp";
import authorCmp from "@/views/word/detailCmp/authorCmp";

export default {
  name: "detail",
  components: {
    imgCmp,
    textCmp,
    phoneCmp,
    authorCmp
  },
  props: {
    visible: {
      type: Boolean,
      required: true
    },
    simIdx: {
      type: String,
      required: true
    },
    result: {
      type: Object,
      required: true
    },
    abnormalResult: {
      type: Object,
      required: true
    },
    phoneAbnormalResult: {
      type: Object,
      required: true
    },
    imageData: {
      type: Object,
      default: () => {
      }
    }
  },
  data() {
    return {
      activeTag: "textSimilar",
      toolHeight: 90,
      toolStatus: true, // true 展开 false 收起
      base: [],
      cont: [],
      baseId: "",
      contId: "",
      fileInfo: {},
      showData: {},
      fullscreen: false
    }
  },
  async created() {
    await this.getFileList()
    await this.getFileData();
    let temp = this.simIdx.split('-');
    this.baseId = temp[0];
    this.contId = temp[1];
    this.filterData()
  },
  mounted() {
    document.addEventListener('fullscreenchange', this.handleListener)
    document.addEventListener('mozfullscreenchange', this.handleListener)
    document.addEventListener('webkitfullscreenchange', this.handleListener)
    document.addEventListener('msfullscreenchange', this.handleListener)
  },

  methods: {
    /**
     * 获取文件列表
     * @returns {Promise<void>}
     */
    async getFileList() {
      let res = await getFileList({
        project: this.projectId,
        sign_name: this.sign_name
      });
      this.fileInfo = res.data;
    },
    /**
     * 构造文件选项
     */
    getFileData() {
      let tb = this.fileInfo.docs;
      let zb = this.fileInfo.bid_doc;
      this.$_.each(tb, (item) => {
        let child = this.$_.map(item.path, (f) => {
          return {
            label: f.file_name,
            value: String(f.uid)
          }
        });
        this.base.push({label: item.tender_name, children: child, value: this.$uuid()});
        this.cont.push({label: item.tender_name, children: child, value: this.$uuid()});
      })
    },
    /**
     * 基准文件切换
     */
    baseChange(idx) {
      this.baseId = idx;
      this.filterData();
    },
    /**
     * 对比文件切换
     */
    contChange(idx) {
      this.contId = idx;
      this.filterData();
    },
    /**
     * 筛选出文件组合的结果
     */
    filterData() {
      let idx = `${this.baseId}-${this.contId}`;
      let temp = this.$_.filter(this.allRes, (item) => {
        return item.idx == idx
      });
      if (temp.length) {
        this.showData = temp[0];
      } else {
        this.showData = {}
      }
    },
    /**
     * 切换工具条的显示隐藏
     */
    toggletoolStatus() {
      this.toolStatus = !this.toolStatus;
      if (this.toolStatus) {
        this.toolHeight = 90
      } else {
        this.toolHeight = 0;
      }
    },

    close() {
      this.$emit('close_detail')
    },
    changeScreen() {
      let element = document.querySelector(".mydialog .el-dialog");
      if (!this.fullscreen) {
        if (element.requestFullscreen) {
          element.requestFullscreen()
        } else if (element.mozRequestFullScreen) {
          //FireFox浏览器全屏
          element.mozRequestFullScreen()
        } else if (element.webkitRequestFullScreen) {
          //Chrome等浏览器全屏
          element.webkitRequestFullScreen()
        } else if (element.msRequestFullscreen) {
          //IE11 浏览器全屏
          element.msRequestFullscreen()
        }
      } else {
        if (document.exitFullscreen) {
          document.exitFullscreen();
        } else if (document.webkitCancelFullScreen) {
          document.webkitCancelFullScreen();
        } else if (document.mozCancelFullScreen) {
          document.mozCancelFullScreen();
        } else if (document.msExitFullscreen) {
          document.msExitFullscreen();
        }
      }
    },
    handleListener() {
      this.fullscreen = !this.fullscreen;
    },
  },
  computed: {
    ...mapState('word', ['projectId', "sign_name", 'hasImg', 'hasPhone', 'hasAuthor', 'hasPara']),
    allRes() {
      // 所有文件的组合情况
      let temp = []
      this.$_.each(this.result, (item) => {
        temp = temp.concat(item.details)
      });
      return temp
    },
    isEmpty() {
      return this.$_.isEmpty(this.showData)
    }
  },
  destroyed() {
    document.removeEventListener('fullscreenchange', this.handleListener)
    document.removeEventListener('mozfullscreenchange', this.handleListener)
    document.removeEventListener('webkitfullscreenchange', this.handleListener)
    document.removeEventListener('msfullscreenchange', this.handleListener)
  }
}
</script>

<style lang="scss" scoped>
.circle {
  height: 75px;
  width: 75px;
  background-image: url('~@/assets/image/circle1.png');
  background-size: 100% 100%;
  background-repeat: no-repeat;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.infoBtn {
  cursor: pointer;
  position: absolute;
  width: 60px;
  height: 20px;
  background-image: url("~@/assets/image/closeBox.png");
  background-repeat: no-repeat;
  background-size: 60px 20px;
  font-size: 12px;
  text-align: center;
  line-height: 20px;
  top: 100%;
  left: calc(50% - 30px);
  color: #fff;
  z-index: 999;

}

.maxIcon {
  width: 20px;
  background-image: url("~@/assets/image/max.png");
  background-size: 20px 20px;
  background-repeat: no-repeat;
  background-position: center;
}

.minIcon {
  width: 20px;
  background-image: url("~@/assets/image/min.png");
  background-size: 20px 20px;
  background-repeat: no-repeat;
  background-position: center;
}
</style>
